import React from 'react';
import PropTypes from 'prop-types';

import {Avatar, Tooltip} from "@mui/material";

import {
    red500,
    blue500,
    green500,
    orange500
} from "assets/jss/main";

RunnerAvatar.propTypes = {
    runner: PropTypes.object.isRequired,
};

const AVATAR_COLORS = [
    blue500,
    green500,
    orange500,
    red500,
];

function getInitials(fullName) {
    const [firstName, lastName] = (fullName ?? '').split(' ');

    return [firstName, lastName]
        .filter(Boolean)
        .map((part) => part.charAt(0).toUpperCase())
        .join('');
}

function getAvatarColor(seed) {
    const charCodeSum = (seed ?? '').split('').reduce((sum, char) => sum + char.charCodeAt(0), 0);

    return AVATAR_COLORS[charCodeSum % AVATAR_COLORS.length];
}

function RunnerAvatar({runner}) {
    const fullName = runner?.user?.fullName;
    const picture = runner?.user?.picture;

    if (picture) {
        return (
            <Tooltip title={fullName}>
                <img
                    src={picture}
                    alt={fullName}
                    style={{
                        width: '32px',
                        height: '32px',
                        borderRadius: '50%',
                        boxShadow: '5px 5px 4px -7px rgba(0,0,0,0.96)',
                        objectFit: 'cover'
                    }}
                />
            </Tooltip>
        );
    }

    return (
        <Tooltip title={fullName}>
            <Avatar sx={{
                width: '32px',
                height: '32px',
                fontSize: '12px',
                backgroundColor: getAvatarColor(runner['@id'] ?? fullName),
                boxShadow: '5px 5px 4px -7px rgba(0,0,0,0.96)'
            }}>
                {getInitials(fullName)}
            </Avatar>
        </Tooltip>
    );
}

export default RunnerAvatar;
